// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2_hbO","content":"RecentSearches_content__-cayg"};